import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { otpModeAdded, startSecurityQuestion } from '../../../../Store/UsersAccount/userAccount.slice.selector';

const SelectOTPMethod = ({ onNext, onBack, buttonName }) => {
    const dispatch = useDispatch()

    const submitMode = (item) => {
        if(item === 'Security'){
            dispatch(startSecurityQuestion())
        }
        dispatch(otpModeAdded(item))
        onNext()
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", textAlign: 'center', gap: "8px" }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                        border: 'none',
                        '&:hover': {
                            border: 'none',
                        }
                    }}
                    onClick={onBack}
                >
                    <ArrowBackIcon/> Back
                </Button>
            </Box>
            <Typography variant="h5" sx={{ fontWeight: '600', paddingBottom:"3px" }}>{buttonName}?</Typography>
            <Typography variant="h6" sx={{ fontSize: "16px", paddingBottom:"3px" }}>Verify Your Identity</Typography>
            <Typography variant="h6" sx={{ fontSize: "16px", paddingBottom:"3px" }}>You will now be required to enter One-Time Security Code to verify your identity.</Typography>
            <Typography variant="h6" sx={{ fontSize: "16px", paddingBottom:"0px" }}>Where would you like to receive the OTP?</Typography>

            <Grid container spacing={2} sx={{marginTop:"7px"}}>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mb: 2,
                            backgroundColor: "#f5365c",
                            borderColor: "#f5365c",
                            '&:hover': {
                                backgroundColor: '#f5365c',
                                color: 'white',
                                border: 'none',
                            }
                        }}
                        onClick={() => submitMode('Email')}>
                        Send to Email
                    </Button>
                </Grid>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mb: 2,
                            backgroundColor: "#f5365c",
                            borderColor: "#f5365c",
                            '&:hover': {
                                backgroundColor: '#f5365c',
                                color: 'white',
                                border: 'none',
                            }
                        }}
                        onClick={() => submitMode('Mobile')}>
                        Text to Mobile
                    </Button>
                </Grid>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mb: 2,
                            backgroundColor: "#f5365c",
                            // textTransform: 'none',
                            borderColor: "#f5365c",
                            '&:hover': {
                                backgroundColor: '#f5365c',
                                color: 'white',
                                border: 'none',
                            }
                        }}
                        onClick={() => submitMode('Security')}>
                        Security Question
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SelectOTPMethod;
